module.exports = {"Born4":{"daobanList":[{"title":"1:是否办新生儿出生一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广东省新生儿“出生一件事”办理登记表","state":"必要"},{"name":"2、有效身份证件（原件）","state":"必要"},{"name":"3、居民户口簿","state":"必要"},{"name":"4、结婚证","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdb-4.json
// module id = 1235
// module chunks = 0